export const islamicFinanceForm = (state) => state.islamicFinanceForm
